<template>
  <div class="user-left-sidebar pt-3" :class="isDarkMode ? 'dark' : ''">
    <b-nav pills vertical class="user-left-sidebar--nav">
      <b-nav-item
        :class="{ active: $route.path === '/user/profile' }"
        to="/user/profile"
        class="pl-5"
      >
        <b-icon icon="person-circle"></b-icon>
        <span>User Profile</span>
      </b-nav-item>
      <b-nav-item
        v-if="currentAgency"
        :class="{ active: $route.path === '/user/templates' }"
        to="/user/templates"
        class="pl-5"
      >
        <b-icon icon="journal"></b-icon>
        <span>Message Templates</span>
      </b-nav-item>
    </b-nav>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "UserLeftSidebar",
  computed: {
    ...mapGetters("user", ["isDarkMode"]),
    ...mapGetters("agency", ["currentAgency"])
  },
};
</script>

<style lang="scss">
.user-left-sidebar {
  width: 100%;
  height: 100%;
  background: #fff;
  &.dark {
    background: #272b34;

    & .nav-item {
      > a {
        color: #b2b9bf;
      }
    }
  }

  & .nav-item {
    display: flex;
    align-items: center;
    height: 50px;
    opacity: 1;

    &.active {
      a {
        color: #186dde !important;
        font-weight: 500;
      }
    }

    > a {
      display: inline-flex;
      align-items: center;
      padding: 0;
      font-size: 14px;
      color: #5b5d60;
      gap: 8px;
    }

    &.convey-connect {
      height: 70px;
      border-bottom: 1px solid #e9ecef;
      opacity: 0.8;
      margin-bottom: 1rem;

      > a {
        font-size: 18px;
        font-weight: 500;
        text-transform: uppercase;
      }
    }
  }
}
</style>